import React from 'react'
import { ShowIf } from '@ztechapps/webui.util'
import { QuantityWithUom } from './QuantityWithUom'

export type UomConversionEquationProps = {
  quantity: number
  symbol: string
  transactionQuantity?: number
  transactionSymbol?: string
  decimalPrecision?: number
  className?: string
}

/**
 * Displays quantity with optional transaction UOM conversion.
 *
 * Format when symbols differ: "{quantity}{symbol} ({transactionQuantity}{transactionSymbol})"
 * Example: "-120in (10ft)" for a sale of 10ft converted to 120in base unit
 *
 * Format when symbols are the same or no transaction info: "{quantity}{symbol}"
 * Example: "30ea" for an adjustment in base units
 */
export const UomConversionEquation = ({
  quantity,
  symbol,
  transactionQuantity,
  transactionSymbol,
  decimalPrecision = 0,
  className,
}: UomConversionEquationProps) => {
  const showTransactionInfo = transactionSymbol != null && transactionSymbol !== symbol

  return (
    <span className={className}>
      <QuantityWithUom quantity={quantity} symbol={symbol} decimalPrecision={decimalPrecision} />
      <ShowIf condition={showTransactionInfo}>
        {' '}
        (
        <QuantityWithUom
          quantity={transactionQuantity ?? 0}
          symbol={transactionSymbol ?? ''}
          decimalPrecision={decimalPrecision}
        />
        )
      </ShowIf>
    </span>
  )
}
